import { render } from "./OrderMain.vue?vue&type=template&id=99c5bdd8&scoped=true"
import script from "./OrderMain.vue?vue&type=script&lang=js"
export * from "./OrderMain.vue?vue&type=script&lang=js"

import "./OrderMain.vue?vue&type=style&index=0&id=99c5bdd8&scoped=true&lang=css"

import exportComponent from "D:\\code\\miao-up-up-mobile-spa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99c5bdd8"]])

export default __exports__